import { render, staticRenderFns } from "./Revolution-Relic.vue?vue&type=template&id=cf2baa82&scoped=true"
import script from "./Revolution-Relic.vue?vue&type=script&lang=js"
export * from "./Revolution-Relic.vue?vue&type=script&lang=js"
import style0 from "./Revolution-Relic.vue?vue&type=style&index=0&id=cf2baa82&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2baa82",
  null
  
)

export default component.exports